import React, { useCallback, useEffect, useState } from "react";
//import ExtractButton from "../ExtractButton/ExtractButton";
import InternalTabs from "../InternalTabsPerf/InternalTabs";
import { Link } from "react-router-dom";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import * as Scroll from "react-scroll";

import PerformanaceValue from "../PerformanceValue/PerformanaceValue";
//import PopupMenu from "../PopupMenu/PopupMenu";
import MenuList from "../MenuList/MenuList";
import { observer } from "mobx-react-lite";
import {
  getLimitPer,
  getTabs,
  lakhAmt,
  numWithUnitPerformance,
  setDerivativeTabKeys,
  sortingFuction,
} from "../../utils/functions";
import unsortedIcon from "../../assets/images/png/upDown.png";
import sortedIcon from "../../assets/images/png/sortedIcon.png";
import sortedAtoz from "../../assets/images/png/descSortIcon.png";
import EmptyPerformance from "../EmptyPerformance/EmptyPerformance";
import AuthStore from "../../store/AuthStore";
import PerformanceStore from "../../store/PerformanceStore";
import UserStore from "../../store/UserStore";
import { useRef } from "react";
import { derivativeTabs } from "../../utils/data";
import StockSelectButton from "./StockSelectButton";
import { overallCustomExcelClms } from "../../utils/constants";
import TableCaption from "../TableCaption/TableCaption";
import NoDataText from "../NoDataText/NoDataText";

const DataWithAnnouncement = ({ isPositive, children }) => {
  return isPositive ? (
    <>
      <span className="sr-only">Positive</span>
      <span className={"green"}>{children}</span>
    </>
  ) : (
    <>
      <span className="sr-only">Negative</span>
      <span className={"red"}>{children}</span>
    </>
  );
};

const PerformanceTabsContent = ({ selectedTab, loaderProp, setLoaderProp }) => {
  // const navigate = useNavigate();
  const popupRef = useRef(null);
  const itemRefs = useRef([]);

  let firstPageTable = [...PerformanceStore.firstPageTable];
  let derivativeDetails = [...PerformanceStore.derivativeDetails];
  let newFirstPageTable = [...firstPageTable];
  let newDerivativeDetails = [...derivativeDetails];
  const [isChecked, setIsChecked] = useState(true);
  const [currentSortingOrder, setCurrentSortingOrder] = useState(null);
  const [currentSortKey, setCurrentSortKey] = useState("");
  const [sortingData, setSortingData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  // const [niftyMenu, setNiftyMenu] = useState(false);
  const [overallExcel, setOverallExcel] = useState({
    isOpen: false,
    status: "default",
  });

  const [announcement, setAnnouncement] = useState("");

  const userHydrated = UserStore.isHydrated;
  const performanceHydrated = PerformanceStore.isHydrated;
  const firstPageData = PerformanceStore.firstPageTable;
  const derivativesDetails = PerformanceStore.derivativeDetails;
  const tableLoader = PerformanceStore.inTableLoader;
  // const isFetched = PerformanceStore.isFirstPageDataFetched;
  const isDerivativeFetched = PerformanceStore.isDerivativeDataFetched;

  const investedValueCellRenderer = (data, key) => {
    switch (key) {
      case "stock_gains":
        return (
          <p className="invested_value_cell font-roboto">
            <span className="red_text">{data[key]}</span>
          </p>
        );
      case "index_gains":
        return (
          <p className="invested_value_cell font-roboto">
            <span className="green_text">{data[key]}</span>
          </p>
        );
      case "instrumentVehicle":
        return (
          <p style={{ paddingLeft: "20px" }} className="invested_value_cell">
            {data?.[key]?.name}
          </p>
        );
      case "absoluteReturn":
        return (
          <p className="invested_value_cell text_align font-roboto">
            <DataWithAnnouncement
              isPositive={
                lakhAmt(data?.[key]?.return?.actual_value) === "-0" ||
                !data?.[key]?.return?.actual_value?.includes("-")
              }
            >
              <>
                {lakhAmt(data?.[key]?.return?.actual_value) === "-0"
                  ? 0
                  : numWithUnitPerformance(
                      data?.[key]?.return?.value,
                      data?.[key]?.return?.value_type,
                    )}
              </>
            </DataWithAnnouncement>
          </p>
        );
      case "xirr":
        return (
          <p className="invested_value_cell text_align  font-roboto">
            {data?.absoluteReturn?.[key] ? (
              <DataWithAnnouncement
                isPositive={
                  data?.absoluteReturn?.[key] ||
                  !data?.[key]?.return?.actual_value?.includes("-")
                }
              >
                <>{`${getLimitPer(data?.absoluteReturn?.[key]) + "%"}`}</>
              </DataWithAnnouncement>
            ) : (
              <NoDataText className="dash" />
            )}
          </p>
        );
      case "benchmark":
        return (
          <p className="invested_value_cell text_align font-roboto">
            <DataWithAnnouncement isPositive={!data?.[key]?.includes("-")}>
              <> {getLimitPer(data?.[key])}%</>
            </DataWithAnnouncement>
          </p>
        );

      case "amt_stock_gains":
        return (
          <p className="invested_value_cell  font-roboto">
            <DataWithAnnouncement isPositive={!data?.[key]?.includes("-")}>
              <>{numWithUnitPerformance(data?.[key], data.type_stock_gains)}</>
            </DataWithAnnouncement>
          </p>
        );
      case "amt_index_gains":
        return (
          <p className="invested_value_cell font-roboto">
            <DataWithAnnouncement isPositive={!data?.[key]?.includes("-")}>
              <>{numWithUnitPerformance(data?.[key], data.type_index_gains)}</>
            </DataWithAnnouncement>
          </p>
        );
      case "derivativeName":
        return (
          <p style={{ paddingLeft: "20px" }} className="invested_value_cell">
            {data[key]}
          </p>
        );

      default:
        return <p className="invested_value_cell">{data[key]}</p>;
    }
  };

  const derivativesRedirect = (data, key) => {
    const redirect = () => {
      PerformanceStore.setDerivativeRef("derivative");
      PerformanceStore.setShowHolding("1");
      PerformanceStore.setCurrentLoader("fullScreen");

      AuthStore.updateLoadingFullScreen(true);
      PerformanceStore.setSecPageDerivateId(data[key]);
      PerformanceStore.setSecPageDuration(
        PerformanceStore.selectedDuration !== undefined
          ? PerformanceStore.selectedDuration
          : "ITD",
      );
      // this is to set title on sub Asset level page i.e. either futures or options
      PerformanceStore.setPerformanceDate({ from: "", to: "" });
      PerformanceStore.setFutreOrOptios(
        data[key] === "1" ? "Futures" : "Options",
      );

      PerformanceStore.setIsClassIdChecked(false);
      // navigate(`/performance/derivatives/${data[key]}`, {
      //   state: { title: data.derivativeName },
      // });
    };
    return (
      <p>
        <Link
          aria-label={`View Details of ${data.derivativeName}`}
          className="accordion_right_btn performance_btn_border_animation buttonBlueBorder"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={redirect}
          to={`/performance/derivatives/${data[key]}`}
          state={{ title: data.derivativeName }}
        >
          <svg
            width="8"
            height="12"
            viewBox="0 0 8 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.93394 5.64683L5.28634 6L4.93394 6.35317L0.706721 10.5896L1.41 11.2929L6.70289 6L1.41 0.707108L0.706722 1.41039L4.93394 5.64683Z"
              fill="white"
              stroke="#404040"
            />
          </svg>
        </Link>
      </p>
    );
  };

  const redirectCellRenderer = (data, key) => {
    // const redirect = () => {
    //   PerformanceStore.setNonDerivativeCheckedStatus(true);
    //   PerformanceStore.setFirstPageRef(data.instrumentVehicle.id);
    //   PerformanceStore.setCurrentLoader("fullScreen");
    //   AuthStore.updateLoadingFullScreen(true);
    //   PerformanceStore.setSecPageTitle(data?.instrumentVehicle);

    //   PerformanceStore.setSecPageDuration(
    //     PerformanceStore.selectedDuration !== undefined
    //       ? PerformanceStore.selectedDuration
    //       : "ITD",
    //   );

    //   PerformanceStore.setIsClassIdChecked(false);
    //   navigate(
    //     `/performance/${"overall performance".replace("/", ";")}/${
    //       PerformanceStore?.selectedAssetClass?.id
    //     }_${data?.instrumentVehicle?.id}`,
    //     {
    //       state: { title: data.instrumentVehicle?.name },
    //     },
    //   );
    // };
    return (
      <p className="btn_cont">
        <Link
          aria-label={`View Details of Sub asset class ${data.instrumentVehicle?.name}`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="accordion_right_btn buttonBlueBorder"
          onClick={() => {
            PerformanceStore.setNonDerivativeCheckedStatus(true);
            PerformanceStore.setFirstPageRef(data.instrumentVehicle.id);
            PerformanceStore.setCurrentLoader("fullScreen");
            AuthStore.updateLoadingFullScreen(true);
            PerformanceStore.setSecPageTitle(data?.instrumentVehicle);

            PerformanceStore.setSecPageDuration(
              PerformanceStore.selectedDuration !== undefined
                ? PerformanceStore.selectedDuration
                : "ITD",
            );

            PerformanceStore.setIsClassIdChecked(false);
          }}
          to={`/performance/${"overall performance".replace("/", ";")}/${
            PerformanceStore?.selectedAssetClass?.id
          }_${data?.instrumentVehicle?.id}`}
          state={{ title: data.instrumentVehicle?.name }}
          //onClick={redirect}
        >
          <svg
            width="8"
            height="12"
            viewBox="0 0 8 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.93394 5.64683L5.28634 6L4.93394 6.35317L0.706721 10.5896L1.41 11.2929L6.70289 6L1.41 0.707108L0.706722 1.41039L4.93394 5.64683Z"
              fill="white"
              stroke="#404040"
            />
          </svg>
        </Link>
      </p>
    );
  };

  const columnsDerivatives = [
    {
      label: "Sub Asset Class",
      key: "derivativeName",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      style: { width: "70%" },
    },
    {
      label: "Stock Gains",
      key: "amt_stock_gains",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Index Gains",
      key: "amt_index_gains",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Action",
      key: "derivativetypeid",
      cellRenderer: derivativesRedirect,
    },
  ];

  const columns = [
    {
      label: "Sub Asset Class",
      key: "instrumentVehicle",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Absolute Return",
      key: "absoluteReturn",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
      align: "right",
    },
    {
      label: "IRR",
      key: "xirr",
      sortable: true,
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Benchmark",
      key: "benchmark",
      cellRenderer: investedValueCellRenderer,
    },
    {
      label: "Action",
      key: "name",
      sortable: false,
      cellRenderer: redirectCellRenderer,
    },
  ];

  const setKeyForSort = (key, label) => {
    const newSortedData = sortingData;

    if (key === currentSortKey) {
      const newData = newSortedData?.slice()?.reverse();

      setCurrentSortingOrder((prev) => !prev);
      setAnnouncement("table sorted");
      setSortingData(newData);
    } else {
      if (key === "instrumentVehicle") {
        const { localKey, arrData, sortOrder } = sortingFuction(
          {
            key1: key,
            key2: "name",
          },
          PerformanceStore.selectedAssetClass.id !== 6
            ? newFirstPageTable
            : newDerivativeDetails,
          true,
        );
        setCurrentSortingOrder(sortOrder);
        setSortingData(arrData);
        setCurrentSortKey(localKey);
      } else if (key === "absoluteReturn") {
        const { localKey, arrData, sortOrder } = sortingFuction(
          { key1: key, key2: "return", key3: "actual_value" },
          PerformanceStore.selectedAssetClass.id !== 6
            ? newFirstPageTable
            : newDerivativeDetails,
          true,
        );
        setCurrentSortingOrder(sortOrder);
        setSortingData(arrData);
        setCurrentSortKey(localKey);
      } else if (key === "xirr") {
        const { localKey, arrData, sortOrder } = sortingFuction(
          { key1: "absoluteReturn", key2: key },
          PerformanceStore.selectedAssetClass.id !== 6
            ? newFirstPageTable
            : newDerivativeDetails,
          true,
        );
        setCurrentSortingOrder(sortOrder);
        setSortingData(arrData);
        setCurrentSortKey(localKey);
      } else {
        const { localKey, arrData, sortOrder } = sortingFuction(
          { key1: key },
          PerformanceStore.selectedAssetClass.id !== 6
            ? newFirstPageTable
            : newDerivativeDetails,
          true,
        );
        setCurrentSortingOrder(sortOrder);
        setSortingData(arrData);
        setCurrentSortKey(localKey);
      }
    }
  };

  const headerRenderer = ({ label, key, sortable, classn, style }) => (
    <th
      aria-sort={
        currentSortKey === key
          ? currentSortingOrder
            ? "Ascending"
            : "Descending"
          : undefined
      }
      style={style || {}}
      className={classn || {}}
      key={key}
    >
      <div className="header_cell">
        {sortable ? (
          <button
            className={"label_wrapper header-button cursor"}
            onClick={() => {
              PerformanceStore.setFirstPageRef("");
              sortable && setKeyForSort(key, label);
            }}
          >
            <p>{label}</p>
            <div className="accordion_table_header_child_icon">
              <img
                src={
                  currentSortingOrder && currentSortKey === key
                    ? sortedIcon
                    : !currentSortingOrder && currentSortKey === key
                      ? sortedAtoz
                      : currentSortKey !== key
                        ? unsortedIcon
                        : ""
                }
                alt="sort"
                aria-hidden={true}
              />
            </div>
          </button>
        ) : (
          <div className={"label_wrapper"}>
            <p>{label}</p>
          </div>
        )}
      </div>
    </th>
  );

  const handleNifty = (data) => {
    PerformanceStore.setCurrentLoader("inTableLoader");
    PerformanceStore.setPerformanceLoader("inTableLoader", true);
    PerformanceStore.setIndex(data?.item);
    PerformanceStore.selectedDuration.length < 6
      ? PerformanceStore.getBenchMarkData("setTable")
      : PerformanceStore.getCustomBenchMark();
    // setNiftyMenu(false);
  };

  const handleTabSelection = (data1, index, allTabs) => {
    const data = data1;
    setLoaderProp(false);

    if (allTabs) {
      PerformanceStore.setFirstPageTableEmpty();
      PerformanceStore.setFirstPageRef("");
      PerformanceStore.setDerivativeRef("");
      PerformanceStore.setLoaderClosingCheck({});
      PerformanceStore.setCurrentLoader("inTableLoader");
      PerformanceStore.setPerformanceLoader("inTableLoader", true);
      if (PerformanceStore.selectedAssetClass.id !== 6) {
        PerformanceStore.setDuration(data);
      } else {
        PerformanceStore.setDuration(setDerivativeTabKeys(index));
      }
      if (PerformanceStore.selectedAssetClass.id !== 6) {
        PerformanceStore.onInternalTabChangeFirstPage();
      } else {
        PerformanceStore.onInternalTabChangeFirstPageDerivative();
      }
    } else if (data !== "CUSTOM") {
      PerformanceStore.setDuration(data);
    }
    setSelectedIndex(index);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      !AuthStore.isLoadingFullScreen &&
      UserStore.isHydrated &&
      PerformanceStore.isHydrated &&
      PerformanceStore.selectedAssetClass.id !== 6
    ) {
      setTimeout(() => {
        const itemToScroll = document.getElementById(
          `${PerformanceStore.selectedFirstRef}`,
        );

        itemToScroll &&
          Scroll.animateScroll.scrollTo(
            itemToScroll.getBoundingClientRect().top,
            {
              isDynamic: true,
              duration: 1700,
              smooth: true,
              delay: 100,
            },
          );

        itemToScroll && PerformanceStore.setFirstPageRef("");
      }, 200);
    }

    return () => {};
  }, [userHydrated, performanceHydrated, firstPageData]);

  useEffect(() => {
    if (
      !AuthStore.isLoadingFullScreen &&
      !PerformanceStore.inTableLoader &&
      UserStore.isHydrated &&
      PerformanceStore.isHydrated &&
      PerformanceStore.selectedAssetClass.id === 6
    ) {
      setTimeout(() => {
        const itemToScroll = document.getElementById(
          `${PerformanceStore.derivativeRef}`,
        );
        itemToScroll &&
          Scroll.animateScroll.scrollTo(
            itemToScroll.getBoundingClientRect().top,
            {
              isDynamic: true,
              duration: 1700,
              smooth: true,
              delay: 100,
            },
          );
        itemToScroll && PerformanceStore.setDerivativeRef("");

        // }
      }, 100);
    }
  }, [userHydrated, performanceHydrated, tableLoader, derivativesDetails]);

  useEffect(() => {
    if (
      PerformanceStore.isFirstPageDataFetched ||
      PerformanceStore.isDerivativeDataFetched
    ) {
      const { localKey, arrData, sortOrder } = sortingFuction(
        PerformanceStore.selectedAssetClass.id !== 6
          ? {
              key1: "instrumentVehicle",
              key2: "name",
            }
          : {
              key1: "derivativeName",
            },
        PerformanceStore.selectedAssetClass.id !== 6
          ? newFirstPageTable
          : newDerivativeDetails,
        true,
      );

      setSortingData(arrData);
      setCurrentSortKey(localKey);
      setCurrentSortingOrder(sortOrder);
    }

    // eslint-disable-next-line
  }, [
    PerformanceStore.inTableLoader,
    PerformanceStore.isFirstPageDataFetched,
    isDerivativeFetched,
    firstPageData,
    derivativesDetails,
  ]);

  const onClickOutside = useCallback(() => {
    // setNiftyMenu(false);
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  useEffect(() => {
    if (loaderProp) {
      PerformanceStore.setFirstPageTableEmpty([]);
      setSortingData([]);
    }
  }, [loaderProp]);

  return (
    <>
      {PerformanceStore.mainTabLoader ||
      (!sortingData.length &&
        PerformanceStore.firstPageTable.length &&
        loaderProp) ? (
        <div className="report_table_loader" style={{ minHeight: "600px" }}>
          <div className="report_loader_wrapper ">
            <img className="loading_gif" src={loaderGIF} alt="loading..." />
          </div>
        </div>
      ) : (
        <>
          <div
            className={`wrapper ${
              PerformanceStore.selectedAssetClass?.name === "Overall" &&
              !PerformanceStore.subTabs.includes(
                PerformanceStore?.selectedDuration,
              )
                ? ""
                : "hide_download"
            }`}
          >
            <div className="container_box cb_title">
              {" "}
              <h2 className="section_heading">{`Your ${getTabs(
                PerformanceStore.selectedAssetClass?.name,
              )} ${
                PerformanceStore.selectedAssetClass?.name === "Overall"
                  ? "Portfolio"
                  : ""
              } Performance`}</h2>
            </div>
            <div className="container_box cb_excel">
              <StockSelectButton
                onClick={({ isChecked }) => {
                  PerformanceStore.getOverallCustomExcelData({
                    excelColumns: overallCustomExcelClms,
                    benchXirr: PerformanceStore?.dropdownData?.xirr,
                    withHoldings: isChecked,
                    onSuccess: () => {
                      setOverallExcel({ isOpen: false, status: "success" });
                    },
                    onFail: ({ error }) => {
                      setOverallExcel((prev) => ({ ...prev, status: "fail" }));
                    },
                  });
                  setOverallExcel((prev) => ({ ...prev, status: "pending" }));
                }}
                isChecked={isChecked}
                setIsChecked={setIsChecked}
                setOverallExcel={setOverallExcel}
                overallExcel={overallExcel}
              />
            </div>
            <div className="container_box cb_BigBx hiddenBox"></div>
            <div className="container_box cb_SmBx hiddenBox"></div>

            <div className="container_box cb_Details">
              <div className="performance_tabs_content_main">
                <div className="content1 date_picker_wrapper">
                  <div
                    className={
                      PerformanceStore.selectedAssetClass?.name.toLowerCase() !==
                      "derivatives"
                        ? "tabs_wrapper"
                        : "tabs_wrapper paddingContent"
                    }
                  >
                    <InternalTabs
                      tabsDataProp={
                        PerformanceStore.selectedAssetClass.id !== 6
                          ? PerformanceStore.subTabs.concat([
                              PerformanceStore.lastTabName,
                            ])
                          : derivativeTabs
                        //  : derivativeTabs.concat([PerformanceStore.lastTabName])
                      }
                      setSelectedTab={(data, index, allTabs) => {
                        handleTabSelection(data, index, allTabs);
                      }}
                      selectedTab={PerformanceStore?.selectedDuration}
                      page="assetPage"
                      selectedIndex={selectedIndex}
                      setSelectedIndex={setSelectedIndex}
                    />

                    {/* {PerformanceStore.selectedAssetClass?.name?.toLocaleLowerCase() !==
                      "derivatives" && (
                      <div
                        ref={popupRef}
                        className="popup-container-performance"
                      >
                        <PopupMenu
                          position={{ top: "60px", right: "-6px" }}
                          type="customNifty"
                          setOpen={setNiftyMenu}
                          open={niftyMenu}
                          MenuContent={() => (
                            <MenuList
                              list={PerformanceStore.indexes}
                              onClick={(data) => handleNifty(data)}
                              customClass="performance"
                            />
                          )}
                          id={"index-menu"}
                          role={"menu"}
                        >
                          <ExtractButton
                            type="nifty"
                            title1={"Compare with"}
                            inFormat={PerformanceStore.selectedIndex}
                            ariaHasPopup="menu"
                            isAiraExpanded={niftyMenu}
                            ariaControls="index-menu"
                            ariaHidden={true}
                            tabIndex={-1}
                          />
                        </PopupMenu>
                      </div>
                    )} */}

                    {PerformanceStore.selectedAssetClass?.name?.toLocaleLowerCase() !==
                      "derivatives" && (
                      <div className="popup-container-performance">
                        <MenuList
                          onClick={(data) => handleNifty(data)}
                          customClass="performance"
                          buttonProps={{
                            buttonType: "normalExport",
                            type: "nifty",
                            title: "Compare with",
                            inFormat: PerformanceStore.selectedIndex,
                          }}
                          popupClassName={{
                            open: "list_menu_open",
                            close: "list_menu_close",
                            wrapperClass: "menu_list_performance",
                          }}
                          restrictHover={true}
                          menuItems={PerformanceStore.indexes}
                          accessibilityValues={{
                            buttonId: "compare-dropdown",
                            ariaHaspopup: "menu",
                            ariaControls: "compare-dropdown",
                            ariaLabel: "Compare With",
                          }}
                          itemRefs={itemRefs}
                        />
                      </div>
                    )}
                  </div>

                  {PerformanceStore.inTableLoader ||
                  (!sortingData.length &&
                    PerformanceStore.firstPageTable.length) ? (
                    <div className="report_table_loader">
                      <div className="report_loader_wrapper add_top_bottom_margin">
                        <img
                          className="loading_gif"
                          src={loaderGIF}
                          alt="loading..."
                        />
                      </div>
                    </div>
                  ) : (
                    <>
                      <div
                        className={
                          selectedTab !== "Derivatives"
                            ? "internal_tabs_content"
                            : "internal_tabs_content marginTop"
                        }
                      >
                        <div className={"each_container_wrapper"}>
                          <PerformanaceValue
                            data={PerformanceStore.monthwiseData}
                            dropDownData={PerformanceStore.dropdownData}
                            derivative2={PerformanceStore.derivativeProfile}
                          />
                        </div>
                      </div>
                      {PerformanceStore.selectedAssetClass.id !== "all" && (
                        <div className="lackvalue"></div>
                      )}
                      <div className="performance_tab_content_table_container">
                        <div
                          aria-live="polite"
                          aria-atomic="true"
                          className="sr-only"
                        >
                          {announcement}
                        </div>{" "}
                        {PerformanceStore.selectedAssetClass?.id === 6 ? (
                          <table className="table accordion_content_derivatives_table">
                            <TableCaption
                              captionName={`${getTabs(
                                PerformanceStore.selectedAssetClass?.name,
                              )} Performance`}
                            />
                            <thead>
                              <tr id={PerformanceStore.derivativeRef}>
                                {columnsDerivatives?.map(headerRenderer)}
                              </tr>
                            </thead>
                            <tbody>
                              {PerformanceStore.isHydrated &&
                              sortingData?.length !== 0 ? (
                                sortingData?.map((eachVehicle) => {
                                  return (
                                    <tr key={eachVehicle.id}>
                                      {columnsDerivatives.map((eachColumn) => {
                                        return (
                                          <td>
                                            {eachColumn?.cellRenderer
                                              ? eachColumn?.cellRenderer(
                                                  eachVehicle,
                                                  eachColumn.key,
                                                  PerformanceStore
                                                    .derivativeDetails[0]
                                                    ?.derivativeSubAssetClass_Details,
                                                )
                                              : JSON.stringify(
                                                  eachVehicle[eachColumn.key],
                                                )}
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan={5}>
                                    <EmptyPerformance />
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        ) : PerformanceStore.selectedAssetClass?.name !==
                          "Overall" ? (
                          <table className="table accordion_content_custom_table">
                            <TableCaption
                              captionName={`${getTabs(
                                PerformanceStore.selectedAssetClass?.name,
                              )} Performance`}
                            />
                            <thead>
                              <tr>{columns?.map(headerRenderer)}</tr>
                            </thead>
                            <tbody>
                              {PerformanceStore.isHydrated &&
                              sortingData &&
                              sortingData?.length !== 0 ? (
                                sortingData?.map((eachVehicle) => {
                                  return (
                                    <tr id={eachVehicle?.instrumentVehicle?.id}>
                                      {columns.map((eachColumn) => {
                                        return (
                                          <td
                                            style={eachColumn.align ? {} : {}}
                                          >
                                            {eachColumn?.cellRenderer
                                              ? eachColumn?.cellRenderer(
                                                  eachVehicle,
                                                  eachColumn.key,
                                                  PerformanceStore.firstPageTable,
                                                )
                                              : JSON.stringify(
                                                  eachVehicle[eachColumn.key],
                                                )}
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan={5}>
                                    <EmptyPerformance />
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        ) : (
                          ""
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default observer(PerformanceTabsContent);
